import React from 'react';
import {Stack, Typography} from '@mui/material';
import './ReadOnlyChip.scss';
import {Criteria} from '../../../../../types/Criteria';

export interface ChipProps {
  criteria: Criteria;
}

const Chip: React.FC<ChipProps> = ({criteria}) => {
  const chipClassName =
    criteria.type === 'Operand' ? 'operand-chip' : 'operator-chip';

  const handlePanelClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <Stack
      direction={'row'}
      spacing={1}
      className={`readonly-chip ${chipClassName}`}
      onClick={handlePanelClick}
      tabIndex={0}
    >
      <Typography
        className="typo-text label3_size"
        data-testid={`read-only-chip-${criteria.id}`}
      >
        {criteria.value}
      </Typography>
    </Stack>
  );
};

export default Chip;
